<template>
  <div class="seasidetms_wrap_pagination col-md-12">
    <ul class="page-numbers" v-if="totalPages > 1">
      <li v-for="(n, i) in pages" :key="`p${i}`">
        <a href="#" class="page-numbers" @click.stop.prevent="onPage(n)">
          {{ n }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'BlogPagination',
  data() {
    return {
      curPage: 1,
    }
  },
  props: {
    total: {
      type: Number,
      required: true,
    },
    event: {
      type: Function,
    },
  },
  /*data() {
      return {
        totalPages: 1,
      }
    },*/
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.postPerPage)
    },
    pages() {
      const pages = []
      for (let i = 1; i <= this.totalPages; i++) {
        // no dots required
        if (this.totalPages < 16) {
          pages.push(i)
          continue
        }
        // first portion of pages
        if (
          (this.curPage < 8 && i <= this.curPage + 3) ||
          (this.curPage > 7 && i < 4)
        ) {
          pages.push(i)
          continue
        }
        // first dots
        if (
          (i === 5 && this.curPage === 1) ||
          (i === this.curPage + 4 && this.curPage > 1 && this.curPage < 8) ||
          (i === 4 && this.curPage > 7)
        ) {
          pages.push(null)
          continue
        }
        // middle portion of pages
        if (i > this.curPage - 3 && i < this.curPage + 4 && this.curPage > 5) {
          pages.push(i)
          continue
        }
        // second dots
        if (
          i === this.totalPages - 4 &&
          this.curPage > 7 &&
          this.curPage < this.totalPages - 4
        ) {
          pages.push(null)
          continue
        }
        // last portion of pages
        if (i > this.totalPages - 3) {
          pages.push(i)
          continue
        }
      }
      return pages
    },
    ...mapGetters(['postPage', 'postPerPage']),
    ...mapActions([]),
  },
  methods: {
    updatePath(n) {
      const { query, path } = this.$route
      const isFirst = n === 1

      if (isFirst) {
        delete query.page
      } else {
        query.page = n
      }

      const queryEntries = Object.entries(query)

      if (queryEntries.length || isFirst) {
        const queries = queryEntries.map(([key, value]) => `${key}=${value}`)
        const helper = queryEntries.length ? '?' : ''
        const newPath = `${path}${helper}${queries.join('&')}`
        history.pushState(query, null, newPath)
      }
    },
    onPrevPage() {
      this.$store.dispatch('resetScroll')
      this.setPostPage(this.curPage - 1)
      this.updatePath(this.curPage - 1)
      this.event()
      this.curPage = this.$store.state.blog.curent_page
    },
    onNextPage() {
      this.$store.dispatch('resetScroll')
      this.setPostPage(this.curPage + 1)
      this.updatePath(this.curPage + 1)
      this.curPage = this.$store.state.blog.curent_page
      this.event()
    },
    onPage(n) {
      // console.log(this.curPage, this.postPerPage, this.total)
      this.$store.dispatch('resetScroll')
      this.setPostPage(n)
      this.curPage = this.$store.state.blog.curent_page
      this.event()
      this.updatePath(n)
    },
    ...mapMutations(['setPostPage']),
  },
  mounted() {
    this.curPage = this.postPage
  },
}
</script>

<style lang="scss" scoped>
a.page-numbers {
  color: #337ab7;
}
a.page-numbers.prev,
a.page-numbers.next {
  color: #333;
}
</style>
